export default __webpack_public_path__ + "static/thirdbatch-f3e6524d737ed98f2bb2178cdc6f8102.png";